import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import { toIdValue } from 'apollo-utilities';
import fragmentTypes from './fragmentTypes';
const createCache = () => new InMemoryCache({
    freezeResults: true,
    fragmentMatcher: new IntrospectionFragmentMatcher({
        introspectionQueryResultData: {
            __schema: {
                types: fragmentTypes
            }
        }
    }),
    cacheRedirects: {
        Query: {
            product: (_, args) => toIdValue(`Product:${args.id}`),
            category: (_, args) => toIdValue(`Category:${args.id}`)
        }
    }
});
export default createCache;
//# sourceMappingURL=cache.js.map